/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_TicketsInputs */

const en_settings_nav_tickets = /** @type {(inputs: Settings_Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Tickets`)
};

/**
* | output |
* | --- |
* | "Support Tickets" |
*
* @param {Settings_Nav_TicketsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_nav_tickets = /** @type {((inputs?: Settings_Nav_TicketsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_TicketsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_nav_tickets(inputs)
});
export { settings_nav_tickets as "settings.nav.tickets" }